module.exports = __webpack_public_path__ + "img/semenov.e5f67351.jpg";